import { allow } from "../actionConstants";

export const allowConciliador = () => ({
  type: allow.ALLOWED
});

export const notAllowConciliador = (redirect = true) => ({
  type: allow.NOT_ALLOWED
});
